(ns frontend.controller.websocket.event
  (:require
   [frontend.conn :as conn]
   [re-frame.core :refer [dispatch reg-fx]]
   [promesa.core :as p]
   [re-frame.core :as rf]
   [frontend.logging :as logging]))

#_(reg-fx
   ::send
   (fn [{:keys [id body on-success on-error]}]
     (let [cb (fn [{:keys [error message] :as response}]
                (if error
                  ;; TODO check if we can just return `{:dispatch […]}` instead
                  (dispatch (conj on-error
                                  (ex-info "Received an error response"
                                           {:error error :message message})))
                  (dispatch (conj on-success
                                  (get-in response [:body :token])))))]
       (conn/send! id body cb))))

(defn ws-send!
  [{:keys [id body on-success on-error auth?]}]
  (logging/performance "SEND Socket rquest " id)
  (-> (conn/sendp! id body 60000 auth?)
      (p/then (fn [resp]
                #_(logging/performance "RECEIVE Socket response " id)
                (rf/dispatch (conj on-success resp))))
      (p/catch #(rf/dispatch (conj on-error %)))))

(defn dispatch-on-request
  [request ws-response]
  (when-let [on-request (:on-request request)]
    (rf/dispatch (conj on-request ws-response))))

(defn websocket-effect
  [request]
  (let [seq-request-maps (if (sequential? request) request [request])]
    (doseq [request seq-request-maps]
      (let [ws-promise (ws-send! request)]
        (dispatch-on-request request ws-promise)))))


(defn websocket-init-effect
  [{:keys [url skip-reconnect? on-message on-connected on-error] :as request}]
  (conn/init!
   url
   (partial rf/dispatch on-message)
   (fn [status]
     (when (= status :websocket.status/not-available)
       (rf/dispatch (conj on-error :websocket.status/not-available))))
   (partial rf/dispatch on-connected)
   (partial rf/dispatch on-error)
   skip-reconnect?))

(defn websocket-closed-effect
  [request]
  (js/console.log "WS closed event"))

(defn websocket-auth-effect
  [auth?]
  (conn/has-valid-session!))

(reg-fx ::initialize websocket-init-effect)
(reg-fx ::send websocket-effect)
(reg-fx ::conn/closed websocket-closed-effect)
(reg-fx ::authenticated! websocket-auth-effect)

(defn init
  []
  (js/console.log "Init websocket"))
